var indentation_default = {
  "indentZero": "Rmy1o",
  "indentOne": "rjpGP",
  "indentTwo": "n12VV",
  "indentThree": "XfNa9",
  "indentFour": "_5jyya",
  "indentFive": "dYriN",
  "indentSix": "sa1Kh"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
